import modalStyle from "./modal.module.scss";

import { ReactComponent as CloseIcon } from "assets/images/icons/icn_close.svg";

import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { SolidButton } from "components/buttons/SolidButton";

const compatibleProductsUrl = "https://www.dlink.com/en/-/media/product-pages/nuclias/nuclias-unity/compatible-products-for-nuclias-unity-solutionv16.pdf";

const ModalDiscoveryNotice = ({ onCloseModal, onNext }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            color: theme.palette.primary.main,
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.customFontSize[5],
            fontWeight: theme.typography.customFontWeight[3],
            paddingLeft: "20px",
          }}
        >
          Device Discovery
        </Typography>
        <Button
          onClick={onCloseModal}
          sx={{
            backgroundColor: theme.palette.primary.transparent,
            boxShadow: "none",
            "&:hover": {
              backgroundColor: theme.palette.primary.transparent,
            },
          }}
        >
          <CloseIcon />
        </Button>
      </Box>

      <Box className={modalStyle.modal_Block} sx={{ margin: "30px 0" }}>
        <Typography
          sx={{
            color: theme.palette.primary.main,
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.customFontSize[5],
            fontWeight: theme.typography.customFontWeight[3],
          }}
        >
          Notice
        </Typography>
      </Box>

      <Box
        className={modalStyle.modal_Block}
        sx={{
          flexDirection: "column",
          alignItems: "center",
          padding: "0 20px",
        }}
      >
        <Typography fontSize="16px" fontWeight="bold" color="rgba(0, 0, 0, 0.8)">
          Please note that the device must be upgraded to a firmware version that supports Nuclias Unity before use.
        </Typography>
        <Typography fontSize="16px" fontWeight="bold" color="rgba(0, 0, 0, 0.8)" sx={{ mt: 1 }}>
          For the list of supported devices and firmware versions, please refer to:
        </Typography>
        <Typography
          component="a"
          href={compatibleProductsUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: "block",
            mt: 1,
            color: theme.palette.primary.main,
            fontSize: "16px",
            textDecoration: "underline",
          }}
        >
          Compatible Products for Nuclias Unity Solution
        </Typography>
      </Box>

      <Box className={modalStyle.modal_operation}>
        <SolidButton
          className={modalStyle.modal_saveBtn}
          style={{ width: "195px", height: "42px", fontSize: "16px" }}
          variant="contained"
          onClick={onNext}
        >
          I Understand
        </SolidButton>
      </Box>
    </Box>
  );
};

export default ModalDiscoveryNotice;
